<h1 mat-dialog-title>Группы товаров</h1>
<div mat-dialog-content>
  
<app-groups-tree [currentGroup]="data" (selectedNode)="onSelectedNode($event)"></app-groups-tree>

</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Закрыть</button>
</div>